import styled from 'styled-components';
import { media } from "../../theme/breakpoints";

export const StyledContainer = styled.div`
    padding: 32px;
    max-width: 1200px;
    background: #ffffff;
    border: 1px solid rgba(224, 224, 224, 1);
    margin: 0 auto;
    border-radius: 40px;
    width: 80%;
    position: relative;
`
export const Header = styled.div`
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    flex-direction: column;
    align-items: flex-start;

    button {
        width: 100%;
    }

    h2 {
        margin: 0;
        flex: 1;
    }

    ${media.sm} {
        flex-direction: row;
        align-items: center;

        button {
            width: auto;
        }
    }
`;
